
import React from "react";
import { Input } from "antd";
import { DataTypeEnum } from "utils/enums";
import { EXPONENTIAL_INPUT_CHARS } from "utils/constants/constants";

const TextInput = React.forwardRef<any, any>((props, ref) =>
  props?.type !== "password" ? (
    <Input
      {...props}
        ref={ref} 
            // If type is NUMERIC, treat it as NUMBER; otherwise, use provided type

      type={props?.type === DataTypeEnum.NUMERIC ? DataTypeEnum.NUMBER : props?.type}

      onKeyDown={(e) => {
          /**
         * Prevent input of exponential notation characters ('e', 'E', '+', '-') 
         * when input type is NUMERIC.
         *
         * Prevent input of exponential characters and decimal point ('.')
         * when input type is NUMBER.
         */
        if (
          (EXPONENTIAL_INPUT_CHARS.includes(e.key) &&
            props?.type === DataTypeEnum.NUMERIC) ||
          ([...EXPONENTIAL_INPUT_CHARS, "."].includes(e.key) &&
            props?.type === DataTypeEnum.NUMBER)
        ) {
          e.preventDefault();

        }
        // Call custom onKeyDown if provided
        if (props.onKeyDown) {
          props.onKeyDown(e);
        }
      }}
      maxLength={props.maxLength || 500}
      autoComplete="off"
    />
  ) : (
    <Input.Password
      {...props}
      ref={ref} 
      maxLength={props.maxLength || 30}
      autoComplete={props.autoComplete || "off"}
      onContextMenu={(e) => e.preventDefault()}
  onPaste={(e) => e.preventDefault()}
  onCopy={(e) => e.preventDefault()}
  onCut={(e) => e.preventDefault()}
    />
  )
);

TextInput.displayName = "TextInput";

export default TextInput;
